import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TenantEffects, tenantReducer, TENANT_STORE_KEY } from './state';
import { SharedUiInputsModule } from '@shared/ui/inputs';
import { ChooseTenantComponent } from './components/choose-tenant/choose-tenant.component';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(TENANT_STORE_KEY, tenantReducer), EffectsModule.forFeature([TenantEffects]), SharedUiInputsModule, SharedFeatureTranslateModule],
  exports: [StoreModule, EffectsModule, ChooseTenantComponent],
  declarations: [ChooseTenantComponent],
})
export class SharedFeatureTenantModule {}
